var widget_default = {
  "card": "jKuR8",
  "link": "cNq8C",
  "container": "LIAvD",
  "image": "fWEyS",
  "right": "RdqUL",
  "cardLayout": "juUq8",
  "content": "Y59GQ",
  "title": "_2ikFG",
  "subtitle": "YxxJT",
  "button": "jyEQf",
  "button_disabled": "Br3DJ",
  "buttonText": "S1Frd",
  "slimLayout": "K1Y7J",
  "contentText": "Kti6p"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
